import { render, staticRenderFns } from "./Transcripts.vue?vue&type=template&id=7813105b&scoped=true&"
import script from "./Transcripts.vue?vue&type=script&lang=js&"
export * from "./Transcripts.vue?vue&type=script&lang=js&"
import style0 from "./Transcripts.vue?vue&type=style&index=0&id=7813105b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813105b",
  null
  
)

export default component.exports